import { differenceInYears } from "date-fns";
const ADULT_MINIMUM_AGE = 18;
const INDEPENDENT_MINOR_MINIMUM_AGE = 13;
function calculateAge(birthday) {
  return differenceInYears(/* @__PURE__ */ new Date(), birthday);
}
function hasMinimumAge(birthday, minimumAgeInYears) {
  return calculateAge(birthday) >= minimumAgeInYears;
}
function isAdult(birthday) {
  return hasMinimumAge(birthday, ADULT_MINIMUM_AGE);
}
export {
  ADULT_MINIMUM_AGE as A,
  INDEPENDENT_MINOR_MINIMUM_AGE as I,
  calculateAge as c,
  hasMinimumAge as h,
  isAdult as i
};
//# sourceMappingURL=utils-X44hCGk3.js.map
